import { useI18n } from 'vue-i18n';

import { committees, orderedCommittees } from '@/constants/committees';
import { Committee } from '@/models';

const deadlineOverrides: Partial<Record<Committee, string>> = {
  [Committee.japan]: 'nextYear',
  [Committee.america]: 'nextYear'
};

export function getCommitteeOptions() {
  const { t } = useI18n();

  return orderedCommittees.map((committee) => {
    const info = committees[committee];
    const deadline = deadlineOverrides[committee] || info.deadline;
    return {
      value: committee,
      label: `${t(`committees.${committee}`)} (${t(deadline)})`
    };
  });
}
